export default "__VITE_ASSET__bbd65701__"